import { debounce, DebouncedFunc } from 'lodash';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IResponseDataBody } from 'services/response';
import { ICustomerInfo } from '../CustomerTab';
import appointmentApis from '../services/apis';
import { bookingV2LoadingRef } from './Loading';
type IInquiryCustomerHandler = {
  onStart: () => void;
  onDone: (data: ICustomerInfo | null) => void;
};
const useInquiryCustomer = (handler: IInquiryCustomerHandler): [({
  data: ICustomerInfo | null;
}), DebouncedFunc<(text: string) => Promise<ICustomerInfo | null | undefined>>] => {
  const { shop_id = '' } = useParams();
  const [customer, setCustomer] = useState<ICustomerInfo | null>(null);
  const _debounce = useCallback(debounce(async (text: string) => {
    const rawPhone = text?.replace(/[^0-9]/g, '');
    if (rawPhone?.length < 10) return;
    handler.onStart();
    bookingV2LoadingRef.current?.open();
    setCustomer(null);
    try {
      const res: IResponseDataBody<ICustomerInfo | null> = await appointmentApis.getCustomerInfo(text, shop_id);
      const resData = res?.data?.data;
      if (resData) {
        handler.onDone(resData);
      }
      return null;
    } catch (error) {
      return null;
    } finally {
      bookingV2LoadingRef.current?.close();
    }
  }, 200), [handler.onDone]);

  return [{ data: customer }, _debounce];
};

export default useInquiryCustomer;
